import type { AppConfig } from 'app/config/app.config';

export function ngrxDevtoolsProviders(_: AppConfig) {
	return [];
}
